import axios from 'axios'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'
import { createGtag } from 'vue-gtag'
import vue3GoogleLogin from 'vue3-google-login'
import i18n from './languages/i18n'

import App from '@/App.vue'
import router from '@/router'

// Default styles
import './assets/main.css'

// Import Main components
// ToDo: Create a script that does this automatically
import MainButton from '@/components/MainButton.vue'
import MainLoader from '@/components/MainLoader.vue'
import MainTopBar from '@/components/MainTopBar.vue'

// import env variables
import { VITE_API_URL, VITE_ANALYTICS_ID, SENTRY_DNS, GOOGLE_CLIENT_ID, MODE, VERSION } from '@/config'

// const errorInterceptor = () => ({})
import { errorInterceptor } from '@/interceptors/error'

// Set default site headers (?)
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.baseURL = VITE_API_URL

// Setup axios interceptors
axios.interceptors.response.use(
  (response) => {
    // Handle backend responses with {meta, data} wrapper structure
    // If response.data has a 'data' field, unwrap it; otherwise return response.data
    return response.data?.data !== undefined ? response.data.data : response.data
  },
  // ERROR
  errorInterceptor,
)

const app = createApp(App)
if (MODE === 'production') {
  Sentry.init({
    app,
    dsn: SENTRY_DNS,
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^https:\/\/www\.emailpref\.com\//, /^https:\/\/[a-zA-Z0-9-]+\.emailpref\.com\//],
    environment: MODE,
    release: VERSION,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
} else if (MODE === 'qa') {
  Sentry.init({
    app,
    dsn: SENTRY_DNS,
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^https:\/\/[a-zA-Z0-9-]+\.emailpref\.com\//],
    environment: MODE,
    release: VERSION,
  })
}

app.use(createPinia())
app.use(i18n)
app.use(router)

// Setup Analytics gtag (skip in test environment)
if (MODE !== 'test') {
  app.use(
    createGtag({
      tagId: VITE_ANALYTICS_ID,
    }),
  )
  // Setup Google Login
  try {
    app.use(vue3GoogleLogin, {
      clientId: GOOGLE_CLIENT_ID,
    })
  } catch (e) {
    // Google auth library may fail to load in some environments (ad blockers, CSP, etc.)
  }
}

// Setup Main components
// ToDo: Create a script that does this automatically
app.component('MainButton', MainButton)
app.component('MainLoader', MainLoader)
app.component('MainTopBar', MainTopBar)

app.mount('#app')

export { i18n }
